import { YinYangIcon } from './YinYangIcon';

/**
 * author: Austin Andrews
 * id 068670F6-B9DF-40C5-8C50-C9A3953F6201
 * name yin-yang
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/yin-yang.svg
 * tags
 */
export const TaoismIcon = YinYangIcon;
export default TaoismIcon